export default __webpack_public_path__ + "987283d56373d2ab014fff8bba4d9f50.ttf";